/**
 * Locale strings for the per-question `conditionalAction` control (branching
 * `goTo` + visibility `show`). Schema-agnostic — any questionnaire-style
 * schema that mounts the control reuses these. Currently used by
 * `masonry-questionnaire.json`.
 */
export const EN_CONDITIONAL_ACTION_STRINGS = {
  CONDITIONAL_ACTION_LABEL: 'Branching',
  CONDITIONAL_ACTION_HINT:
    'Define how the flow continues after this question is answered. Rules are evaluated in order; the first match wins. Leave empty to continue to the next question in linear order.',
  CONDITIONAL_ACTION_EMPTY_HINT:
    'Add a rule to send members to different questions based on how they answer',
  SHOW_WHEN_LABEL: 'Visibility',
  SHOW_WHEN_HINT:
    "Show this question only when one of the rules below is met. If none match, the question is hidden. With no rules, it's always shown.",
  SHOW_WHEN_EMPTY_TITLE: 'This question is always shown',
  SHOW_WHEN_EMPTY_HINT:
    'Add a rule to show this question only when an earlier answer matches.',
  SHOW_WHEN_ADD_RULE: 'Add rule',
  SHOW_WHEN_THEN_LABEL: 'show this question',
  CONDITIONAL_ACTION_RULES_LABEL: 'Rules',
  CONDITIONAL_ACTION_ADD_RULE_LABEL: 'Add rule',
  CONDITIONAL_ACTION_RULE_ITEM_LABEL: 'Rule',
  CONDITIONAL_ACTION_IF_LABEL: 'If',
  CONDITIONAL_ACTION_THEN_LABEL: 'Then',
  CONDITIONAL_ACTION_GO_TO_LABEL: 'go to',
  CONDITIONAL_ACTION_CHOOSE_DESTINATION: 'Choose destination',
  CONDITIONAL_ACTION_DEFAULT_LABEL: 'All other cases go to',
  CONDITIONAL_ACTION_DEFAULT_HINT:
    'Where the flow goes when no rule above matches. Leave empty to continue linearly.',
  CONDITIONAL_ACTION_INCLUDES_LABEL: 'is any of',
  CONDITIONAL_ACTION_NOT_INCLUDES_LABEL: 'is none of',
  CONDITIONAL_ACTION_GREATER_THAN_LABEL: 'is greater than',
  CONDITIONAL_ACTION_GREATER_THAN_OR_EQUAL_LABEL: 'is greater than or equal to',
  CONDITIONAL_ACTION_LESS_THAN_LABEL: 'is less than',
  CONDITIONAL_ACTION_LESS_THAN_OR_EQUAL_LABEL: 'is less than or equal to',
  CONDITIONAL_ACTION_ANSWER_SUBJECT_LABEL: 'answer',
  CONDITIONAL_ACTION_CHOOSE_DATA_POINT: 'Choose a data point',
  CONDITIONAL_ACTION_REMOVE_DATA_POINT_ARIA: 'Remove {label}',
  CONDITIONAL_ACTION_OPERATOR_PLACEHOLDER: 'Pick an operator',
  CONDITIONAL_ACTION_ADD_VALUE: 'Add value',
  CONDITIONAL_ACTION_COMPARISON_VALUE: 'Comparison value',
  CONDITIONAL_ACTION_ALL_OPTIONS_SELECTED: 'All options selected',
  CONDITIONAL_ACTION_NO_VALUE_OPTIONS_AVAILABLE:
    'No values available — add options to the source first',
  CONDITIONAL_ACTION_MISSING_DESTINATION: 'Missing destination ({id})',
  CONDITIONAL_ACTION_REMOVE_VALUE_ARIA: 'Remove {code}',
  CONDITIONAL_ACTION_SOURCE_LABEL: 'Condition source',
  CONDITIONAL_ACTION_OPERATOR_LABEL: 'Operator',
  CONDITIONAL_ACTION_SUBJECT_QUESTION_LABEL: 'Subject question',
  CONDITIONAL_ACTION_CHOOSE_SUBJECT_QUESTION: 'Choose a question',
  CONDITIONAL_ACTION_EMPTY_TITLE: 'No branching rules yet',
  CONDITIONAL_ACTION_LINEAR_NEXT_NOTE:
    'With no rules set, members continue to the next question in linear order after answering.',
  CONDITIONAL_ACTION_RULE_NUMBER_LABEL: 'Rule {number}',
  CONDITIONAL_ACTION_DELETE_RULE_ARIA: 'Delete rule',
  CONDITIONAL_ACTION_ADD_CONDITION_LABEL: 'Add condition',
  CONDITIONAL_ACTION_AND_LABEL: 'and',
  CONDITIONAL_ACTION_NO_OPERATORS_FOR_ANSWER_TYPE:
    "No operators available for this question's answer type",
  CONDITIONAL_ACTION_UNRECOGNIZED_CONDITION: 'Unrecognized condition',
  CONDITIONAL_ACTION_REMOVE_CONDITION_ARIA: 'Remove condition',
};
